export default __webpack_public_path__ + "static/media/DSClogo.797aa7c5.png";